import { makeStyles } from "@material-ui/core";

export const showConversation = makeStyles(theme=>({
    root:{

    },
    message:{
        width:"100%",
        display:"flex",
        alignItems:"flex-end",
        marginBottom:"20px",
        "& .avatar":{
            fontSize:".6rem",
            margin:"0 10px",
            backgroundColor: theme.palette.grey[200],
            color:"#000"
        },
        "& .adminAvatar":{
            backgroundColor:theme.palette.primary.lighter,
        },
        // flexDirection:"column",
        "& .mainWrapper":{
            flex:1,
            borderRadius: "1.15rem",
            lineHeight: "1.25",
            maxWidth: "90%",
            padding: "0.5rem .8rem",
            position: "relative",
            wordWrap: "break-word",
            "& p":{
                textAlign:"justify",
                fontSize:".9rem",
                width:"100%",
                lineHeight:"2",
                [theme.breakpoints.down("sm")]:{
                    fontSize:"0.8rem"
                }
            },
            "& .top":{
                display:"flex",
                alignItems:"center",
                justifyContent:"space-between",
                "& p":{
                    fontSize:"0.85rem"
                }
            }
        },
        "& .admin":{
            width:"100%",
            marginBottom:"1rem",
            padding: "1rem 1.5rem",
            alignSelf:" flex-end",
            backgroundColor: theme.palette.primary.lighter,
            // color: "#fff",
            position:"relative",
            
            "&:after":{
                transform:"skewX(-25deg)",
                content: '""',
                position: "absolute",
                top: "100%",
                left: "13px",
                borderWidth: "10px 10px 0 0",
                borderStyle: "solid",
                borderColor: `${theme.palette.primary.lighter} transparent`
            },
            
        },
        "& .user":{
            width:"100%",
            marginBottom:"1rem",
            padding: "1rem",
            alignSelf:" flex-start",
            backgroundColor: theme.palette.grey[200],
            // color: "#fff",
            position:"relative",
            "&:after":{
                transform:"skewX(55deg)",
                content: '""',
                position: "absolute",
                top: "100%",
                right: "13px",
                borderWidth: "10px 10px 0 0",
                borderStyle: "solid",
                borderColor: `${theme.palette.grey[200]} transparent`
            },
        }
    },
    sendMessage:{
        position:"relative",
        margin:"20px 0",
        "& .sendIcon":{
            position:"absolute",
            left:2,
            bottom:"13%",
            transform:"rotate(180deg)"
        }
    },
    textarea:{
        borderRadius:"10px",
        outline:"none",
        resize:"none",
        width:"100%",
        border:"1px solid #d6d6d6",
        padding:"5px 31px",
        height:"35px",
        overflow:"hidden"
    },
    chooseFile:{
        width:"100%",
        height:"100%"
    },
    inputContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& label': {
            margin: '0 5px',
        },
    },
}))